export const getActiveMagicFrameActive = () => {
  if (!window.canvas.getActiveObject()) {
    return;
  }

  if (
    window.canvas.getActiveObject().type === 'image' &&
    window.canvas.getActiveObject()._magicFrame
  ) {
    return window.canvas.getActiveObject()._magicFrame;
  } else if (window.canvas.getActiveObject().type === 'MagicFrame') {
    return window.canvas.getActiveObject();
  }
};
